import { Link } from 'react-router-dom';
import { ArrowLeft, Home, Search } from 'lucide-react';

import cave from "../assets/fphc_cave.jpeg"

const NotFound = () => {
  return (
    <div className="relative min-h-screen flex items-center">
      <div className="absolute inset-0 z-0">
        <img
          src={cave}
          alt="Background"
          className="object-cover w-full h-full brightness-[0.4]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/30 via-transparent to-dark" />
      </div>
      
      <div className="container mx-auto px-4 z-10">
        <div className="max-w-2xl mx-auto text-center">
          <div className="inline-flex items-center space-x-3 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-xl mb-8 animate-fade-in">
              <div className="flex gap-1">
                <div className="w-2.5 h-2.5 bg-[#75B2DD] rounded-[2px] animate-pulse-first"></div>
                <div className="w-2.5 h-2.5 bg-[#B5E2BF] rounded-[2px] animate-pulse-second"></div>
                <div className="w-2.5 h-2.5 bg-[#009E60] rounded-[2px] animate-pulse-third"></div>
              </div>
            <span className="text-success font-medium">404 Error</span>
          </div>

          <div className="space-y-6 animate-slide-up">
            <h1 className="text-5xl sm:text-6xl md:text-7xl font-bold text-white leading-tight drop-shadow-lg">
              Seite <span className="text-[#B5E2BF]">nicht</span> gefunden
            </h1>
            
            <div className="w-20 h-1.5 bg-gradient-to-r from-success to-success/30 rounded-full mx-auto" />
            
            <p className="text-lg sm:text-xl text-white leading-relaxed drop-shadow">
              Die von Ihnen gesuchte Seite existiert leider nicht oder wurde verschoben.
            </p>
          </div>

          <div className="mt-12 animate-fade-in" style={{ animationDelay: '0.3s' }}>
            <Link
              to="/"
              className="inline-flex items-center space-x-2 text-white/80 hover:text-white transition-colors group"
            >
              <ArrowLeft className="w-4 h-4 transform group-hover:-translate-x-1 transition-transform" />
              <span>Zurück zur Startseite</span>
            </Link>
          </div>
        </div>
      </div>
      
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-dark to-transparent z-[5]" />
    </div>
  );
};

export default NotFound;